var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOutNaranja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.660377,
    y: 0.660377,
    width: 37.6792,
    height: 37.6792,
    rx: 18.8396,
    stroke: "#F5782A",
    strokeWidth: 1.32075
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14 14.2V23.79C14 27 16 29 19.2 29H21.79C24.99 29 26.99 27 26.99 23.8V14.2C27 11 25 9 21.8 9H19.2C16 9 14 11 14 14.2Z",
    fill: "#F5782A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.43 15.12L20.78 18.47C21.07 18.76 21.07 19.24 20.78 19.53L17.43 22.88C17.14 23.17 16.66 23.17 16.37 22.88C16.08 22.59 16.08 22.11 16.37 21.82L18.44 19.75H7.75C7.34 19.75 7 19.41 7 19C7 18.59 7.34 18.25 7.75 18.25H18.44L16.37 16.18C16.22 16.03 16.15 15.84 16.15 15.65C16.15 15.46 16.22 15.27 16.37 15.12C16.66 14.82 17.13 14.82 17.43 15.12Z",
    fill: "#F5782A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutNaranja);
export default __webpack_public_path__ + "static/media/log-out-naranja.95416ed463ab57fd64adb116aaf6d608.svg";
export { ForwardRef as ReactComponent };